module.exports = __webpack_public_path__ + "static/media/xinyuzijin.e638dd7d.png";